export const IMAGE_PLACEHOLDER_URL = '/images/block/placeholder.png';
export const LIGHTBOX_CLASSNAME = 'js-image--lightbox';
